import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { withLocalize } from 'react-localize-redux';
import dayjs from 'dayjs';

// Import the required locales
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';

/**
 * DatePickerProvider component that provides date picker functionality to the application.
 * This replaces the older MuiPickersUtilsProvider with the new MUI v5 LocalizationProvider.
 * Now supports dynamic locale switching based on the active language.
 */
const DatePickerProvider = ({ children, activeLanguage }) => {
  const locale = activeLanguage?.code || 'es';
  
  // Set the global dayjs locale
  React.useEffect(() => {
    dayjs.locale(locale);
  }, [locale]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      {children}
    </LocalizationProvider>
  );
};

export default withLocalize(DatePickerProvider); 